// @flow
import { useContext } from 'react';

import { EstimateContext } from '../contexts/EstimateContext';

export const useEstimateVersion = () => {
  const estimate = useContext(EstimateContext);
  return estimate?.inputs?.estimate_version;
};
